import api from './api';

export interface Contractor {
  _id: string;
  name: string;
  email: string;
  phone?: string;
  company?: string;
  contractorTypeSlug: string;
  contractorTypeName: string;
  contractorTypeIcon?: string;
  notes?: string;
  isActive: boolean;
  agencyId: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Fetch all contractors for an agency
 */
export const getContractors = async (agencySlug: string): Promise<Contractor[]> => {
  try {
    const response = await api.get(`/agencies/${agencySlug}/contractors`);
    return response.data;
  } catch (error) {
    console.error('Error fetching contractors:', error);
    throw error;
  }
};

/**
 * Fetch contractors filtered by type
 */
export const getContractorsByType = async (agencySlug: string, contractorTypeSlug: string): Promise<Contractor[]> => {
  try {
    const response = await api.get(`/agencies/${agencySlug}/contractors`, {
      params: { type: contractorTypeSlug }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching contractors of type ${contractorTypeSlug}:`, error);
    throw error;
  }
};

/**
 * Fetch a single contractor by ID
 */
export const getContractor = async (agencySlug: string, contractorId: string): Promise<Contractor> => {
  try {
    const response = await api.get(`/agencies/${agencySlug}/contractors/${contractorId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching contractor:', error);
    throw error;
  }
};

/**
 * Create a new contractor
 */
export const createContractor = async (agencySlug: string, contractorData: Partial<Contractor>): Promise<Contractor> => {
  try {
    const response = await api.post(`/agencies/${agencySlug}/contractors`, contractorData);
    return response.data;
  } catch (error) {
    console.error('Error creating contractor:', error);
    throw error;
  }
};

/**
 * Update an existing contractor
 */
export const updateContractor = async (agencySlug: string, contractorId: string, contractorData: Partial<Contractor>): Promise<Contractor> => {
  try {
    const response = await api.put(`/agencies/${agencySlug}/contractors/${contractorId}`, contractorData);
    return response.data;
  } catch (error) {
    console.error('Error updating contractor:', error);
    throw error;
  }
};

/**
 * Delete a contractor
 */
export const deleteContractor = async (agencySlug: string, contractorId: string): Promise<void> => {
  try {
    await api.delete(`/agencies/${agencySlug}/contractors/${contractorId}`);
  } catch (error) {
    console.error('Error deleting contractor:', error);
    throw error;
  }
};

